import { useCollaboration } from '../stores/CollaborationContext'
import { useAuth } from '../stores/AuthContext'
import './PresenceIndicator.css'

export default function PresenceIndicator() {
  const { activeUsers } = useCollaboration()
  const { user } = useAuth()

  // Filter out current user
  const otherUsers = activeUsers.filter(presence => presence.userId !== user?.id)

  if (otherUsers.length === 0) return null

  return (
    <div className="presence-indicator">
      <div className="presence-avatars">
        {otherUsers.slice(0, 5).map((presence) => (
          <div
            key={presence.userId}
            className="presence-avatar"
            title={presence.userName || 'Anonymous'}
            style={{
              backgroundColor: stringToColor(presence.userId)
            }}
          >
            {getInitials(presence.userName)}
          </div>
        ))}
        {otherUsers.length > 5 && (
          <div className="presence-avatar presence-overflow">
            +{otherUsers.length - 5}
          </div>
        )}
      </div>
      <div className="presence-text">
        {otherUsers.length} {otherUsers.length === 1 ? 'person' : 'people'} viewing
      </div>
    </div>
  )
}

// Helper functions
function getInitials(name) {
  if (name) {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
  }
  return '?'
}

function stringToColor(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  const hue = hash % 360
  return `hsl(${hue}, 65%, 50%)`
}
